import { render, staticRenderFns } from "./FreeMonthsBenefitNotificationBox.vue?vue&type=template&id=7b3111b0&scoped=true&"
import script from "./FreeMonthsBenefitNotificationBox.vue?vue&type=script&lang=js&"
export * from "./FreeMonthsBenefitNotificationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3111b0",
  null
  
)

export default component.exports